import { act_com } from '@lc/action/cardType/Common';
import { act_event } from '@lc/action/cardType/Event';
import { createCardEventVerbose } from '@lc/interface/card/event/factory';
import { Event } from '@lc/interface/card/event/types';
import { GameState } from '@lc/interface/gameState/types';

export const getEventVerbose = (EventMeta: Event[]) => [
	createCardEventVerbose(
		EventMeta[0],
		(
			playerData: any,
			gameState: GameState // 144
		) => act_event.spareCalculatorBatteries(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[1],
		(
			playerData: any,
			gameState: GameState // 145
		) => act_event.heDidIt(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[2],
		(
			playerData: any,
			gameState: GameState // 146
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[3],
		(
			playerData: any,
			gameState: GameState // 147
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[4],
		(
			playerData: any,
			gameState: GameState // 148
		) => act_event.forceDonation(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[5],
		(
			playerData: any,
			gameState: GameState // 149
		) => act_event.contributionMatching(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[6],
		(
			playerData: any,
			gameState: GameState // 150
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[7],
		(
			playerData: any,
			gameState: GameState // 151
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[8],
		(
			playerData: any,
			gameState: GameState // 152
		) => act_event.hacktivist(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[9],
		(
			playerData: any,
			gameState: GameState // 153
		) => act_event.karma(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[10],
		(
			playerData: any,
			gameState: GameState // 154
		) => act_event.overcharge(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[11],
		(
			playerData: any,
			gameState: GameState // 155
		) => act_event.overcharge(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[12],
		(
			playerData: any,
			gameState: GameState // 156
		) => act_event.overcharge(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[13],
		(
			playerData: any,
			gameState: GameState // 157
		) => act_event.investigativeJournalism(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[14],
		(
			playerData: any,
			gameState: GameState // 158
		) => act_event.rivalSocial(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[15],
		(
			playerData: any,
			gameState: GameState // 159
		) => act_com.rechargeBattery(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[16],
		(
			playerData: any,
			gameState: GameState // 160
		) => act_com.rechargeBattery(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[17],
		(
			playerData: any,
			gameState: GameState // 161
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[18],
		(
			playerData: any,
			gameState: GameState // 162
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[19],
		(
			playerData: any,
			gameState: GameState // 163
		) => act_event.garageSale(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[20],
		(
			playerData: any,
			gameState: GameState // 164
		) => act_event.garageSale(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[21],
		(
			playerData: any,
			gameState: GameState // 165
		) => act_com.notPlayable(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[22],
		(
			playerData: any,
			gameState: GameState // 166
		) => act_com.stealCardForEnergy(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[23],
		(
			playerData: any,
			gameState: GameState // 167
		) => act_event.fizzyDizzy(playerData, gameState)
	),
	createCardEventVerbose(
		EventMeta[24],
		(
			playerData: any,
			gameState: GameState // 168
		) => act_com.drawCards(playerData, gameState, 3)
	),
	createCardEventVerbose(
		EventMeta[25],
		(
			playerData: any,
			gameState: GameState // 169
		) => act_com.drawCards(playerData, gameState, 3)
	),
];
